const endpoints = {
    QUERY_GRAPHQL: '/catalog-agg-query/graphql',
    SHOPPING_CART: '/shopping-cart/v3/shoppingCart',
    GET_SHOPPING_CART: '/shopping-cart-projection/v3/shoppingCart',
    QUALIFY_PRODUCTS: '/product-offering-qualification-management/v3/qualifyProducts',
    CAPTURE_DATA: '/checkout-api/v3/checkout/captureData',
    CHECKOUT_STRUCTURE: '/checkout-api/v3/checkout/structure',
    TCC_ELIGIBILITY_CHECK: '/bmi-tcc-eligibility/services/tcc/eligibilityCheck',
    GET_CUSTOMER_RELATED_ACCOUNT: '/bmi-customer-management/services/installedbase/getCustomerProductDetails',
    GET_MSISDN: '/resource-pool-management/services/resourcePoolManagement/AvailabilityCheck',
    RESERVE_MSISDN: '/resource-pool-management/services/resourcePoolManagement/Reservation',
    UNPAID_BILLS: '/bmi-customer-unpaidbills/services/customer/dues',
    GET_SECURITY_DEPOSIT: '/bmi-customer-security-deposit/services/deposit/get',
    DELIVERY_COVERAGE_CHECK: '/api/v1/dp/r2r/oto/checkCoverage',
    // FTTH_COVERAGE_CHECK: '/bmi-serviceability/serviceability/mobily',
    FTTH_FEASIBILITY_CHECK: '/bmi-serviceability/services/serviceability/non-mobily',
    GENERATE_ORDER: '/OrderGenerator/postProductOrder',
    GENERATE_ORDER_PRESSA: '/OrderGenerator/pressa/postProductOrder',
    GENERATE_ORDER_SIMSWAP: '/OrderGenerator/sim-swap/v1/postProductOrder',
    GET_CHECKOUT_STRUCTURE: '/checkout-projection/v3/checkout',
    GET_SIM_DETAILS: '/bmi-sim-details/services/sim/get',
    TCC_REGISTRATION: '/bmi-tcc-eligibility/services/tcc/register',
    GET_QR_CODE: '/mobily-qr-code/services/qr/v1/get',
    EMAIL_SERVICE: '/mobily-qr-code/services/qr/v1/send',
    INITIATE_OTP: '/mobily-otp-services/services/otp-rayah/initiate',
    VALIDATE_OTP: '/mobily-otp-services/otp-rayah/validate',
    GET_CUSTOMER_DETAILS: '/bmi-customer-management/services/customer',
    FAMILY_PLAN_CHECK: '/bmi-customer-management/services/installedbase/familyPlan',
    GET_APPOINTMENTS: '/bmi-appointments/services/appointments/mobily/get',
    RESERVE_APPOINTMENT: '/bmi-appointments/services/appointments/mobily/reserve',
    GET_APPOINTMENTS_NON_MOBILY: '/bmi-appointments/services/appointments/non-mobily/get',
    RESERVE_APPOINTMENT_NON_MOBILY: '/bmi-appointments/services/appointments/non-mobily/reserve',
    UPDATE_VALIDATE_SHOPPING_CART: '/mobily-shopping-cart-management/api/update-and-validate',
    CREATE_ORDER_ID: '/OrderGenerator/generateOrderId',
    GET_ODB_DETAILS: '/wiremock/non-mobily/serviceability/getODBDetails',
    VALIDATE_SIM: '/bmi-sim-details/mobily/simvalidationandorc',
    DELIVERY_SEND_OTP: '/utility/v1/otp/send',
    DELIVERY_RESEND_OTP: '/utility/v1/otp/resend',
    DELIVERY_VALIDATE_OTP: '/utility/v1/otp/validate',
    MOBILY_OTP_INITIATE: '/mobily-otp-services/services/otp/generation',
    MOBILY_OTP_VALIADTE: '/mobily-otp-services/services/otp/validation',
    MOBILY_OTP_REGENERATE: '/mobily-otp-services/services/otp/regeneration',
    INITIATE_PAYMENT: '/cem/bff/dpc/v1/initiatePayment',
    ESIM_VALIDATION: '/bmi-sim-details/services/esim/v1/validation',
    INITIATE_PAYMENT_ECOM: '/cem/bff/ecom/v1/initiatePayment',
    INITIATE_PAYMENT_ECOM_ESIM: '/cem/bff/ecom/esim/v1/initiatePayment',
    RETRIEVE_APPOINTMENTS: '/api/v1/dp/r2r/oto/retrieveslots',
    CEM_INITIATE_OTP: '/cem/bff/login/v1/initiate',
    CEM_VALIDATE_OTP: '/cem/bff/login/v1/validate',
    CEM_RESEND_OTP: '/cem/bff/otp/v1/resend',
    DELIVERY_SEND_CEM_OTP: '/cem/bff/otp/v1/send',
    DELIVERY_VALIDATE_CEM_OTP: '/cem/bff/otp/v1/validate',
    DELIVERY_RESEND_CEM_OTP: '/cem/bff/otp/v1/resend',
    AUDIT_SERVICE_SAVE: '/api/mobily-audit-service/audit/save',
    TCC_ERROR_MAPPING_API: 'api/digital/v1/data/mappings?contextId=CTX_PORTAL&catalogKey=TCC_REGISTER_ERROR_CODES',
    GET_MAIN_AND_AROUND_ODB: '/api/v1/dp/gis/GetMainAndAroundODB',
    IVR_CALL_BACK_STATUS: '/cem/bff/ivr-callback/auth/v1/status'
} as const;

export default endpoints;